<template>
  <div class="d-flex align-center flex-column">
    <zp-plans v-model="showPlans"></zp-plans>
    <div class="d-flex flex-column pt-6" style="max-width: 920px; width: 100%">
      <div>
        <div class="d-flex align-end justify-space-between" style="max-width: 365px;">
          <div class="d-flex flex-column" style="line-height: 1.2; position: relative; bottom: -7px;">
            <span>Plano</span>
            <span class="font-weight-bold teal--text text--accent-4" style="font-size: 2em;">{{user.plan.name}}</span>
          </div>
          <v-btn depressed color="green darken-2" dark @click="showPlans = true">
            {{user.trial_active ? 'Ativar plano' : 'Fazer upgrade'}}
          </v-btn>
        </div>
        <div class="caption d-flex blue--text mt-3">
          <span>Usuário registrado em {{user.created_at | date | lowercase}}</span>
          <template v-if="isActivePlan && !user.trial_active">
            <span class="pl-1 pr-1">|</span>
            <strong>Plano ativo até {{user.active_plan_at | date | lowercase}}</strong>
          </template>
          <template v-if="isActivePlan && user.trial_active">
            <span class="pl-1 pr-1">|</span>
            <strong :class="regressiveTime.color">Período de teste. Você tem {{regressiveTime.text}}!</strong>
          </template>
          <template v-if="!isActivePlan && user.trial_active">
            <span class="pl-1 pr-1">|</span>
            <strong>Período de teste encerrado!</strong>
          </template>
        </div>
      </div>
      <div class="mt-5 black--text">
        <div>Itens do seu plano</div>
        <div class="items d-flex mt-3">
          <div class="d-flex align-start">
            <v-icon color="black">mdi-account</v-icon>
            <div class="d-flex flex-column ml-1" style="line-height: 1.2">
              <span v-if="user.max_users < 1000000">{{user.max_users}} usuário(s)</span>
              <span v-else>Usuários ilimitados</span>
              <span class="red--text" style="font-size: .8em;">{{1 + user.team.length}} utilizado(s)</span>
            </div>
          </div>
          <div class="d-flex align-start ml-7">
            <v-icon color="black">mdi-folder-outline</v-icon>
            <div class="d-flex flex-column ml-1" style="line-height: 1.2">
              <span v-if="user.max_projects < 1000000">{{user.max_projects}} projeto(s)</span>
              <span v-else>Projetos ilimitados</span>
              <span class="red--text" style="font-size: .8em;">{{user.projects}} utilizado(s)</span>
            </div>
          </div>
          <div class="d-flex align-start ml-7">
            <v-icon color="black">mdi-link</v-icon>
            <div class="d-flex flex-column ml-1" style="line-height: 1.2">
              <span v-if="user.max_links < 1000000">{{user.max_links}} link(s)</span>
              <span v-else>Links ilimitados</span>
              <span class="red--text" style="font-size: .8em;">{{user.links}} utilizado(s)</span>
            </div>
          </div>
          <div class="d-flex align-start ml-7">
            <v-icon color="black">mdi-web</v-icon>
            <div class="d-flex flex-column ml-1" style="line-height: 1.2">
              <span v-if="user.max_domains < 1000000">{{user.max_domains}} domínio(s)</span>
              <span v-else>Domínios ilimitados</span>
              <span class="red--text" style="font-size: .8em;">{{user.domains}} utilizado(s)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ZpPlans from '@/components/Plans'

export default {
  components: {
    ZpPlans
  },
  data () {
    return {
      loading: false,
      showPlans: false,
      now: Date.now(),
      form: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    regressiveTime () {
      const t = moment(this.user.active_plan_at || 0).valueOf() - this.now

      const days = Math.floor(t / (1000 * 60 * 60 * 24))
      const hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60))
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((t % (1000 * 60)) / 1000)

      return {
        color: days <= 1 ? 'red--text' : 'black--text',
        text: `${days}d ${hours}h ${minutes}m ${seconds}s`
      }
    }
  },
  mounted () {
    if (this.$route.query.show) {
      this.showPlans = true
    }
  },
  beforeCreate () {
    this.interval = setInterval(() => this.now = Date.now(), 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>

</style>